"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FullscreenContext_1 = __importDefault(require("./FullscreenContext"));
var useFullscreen = function () {
    var value = (0, react_1.useContext)(FullscreenContext_1.default);
    if (value === null) {
        throw new Error('useFullscreen must be used inside FullscreenProvider');
    }
    return value;
};
exports.default = useFullscreen;
